import { memo } from "react";
import { classNames } from "helpers";
import { WAREHOUSE_WEEK_DAYS } from "services/api/fleet/warehouses/consts";
import { formatWarehouseHours, getWarehouseToday } from "services/api/fleet/warehouses/transformations";
import { Badge } from "ui/components/Badge";
import { WarehouseWorkingHoursCardProps } from "./types";

/** Trenutno vrijeme kao "HH:mm", da se usporedi s radnim vremenom zapisanim istim oblikom. */
const getCurrentTime = () => {
  const now = new Date();
  return `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
};

/** Radno vrijeme skladišta po danima: je li sada otvoreno, a ispod cijeli tjedan s istaknutim današnjim danom. */
const WarehouseWorkingHoursCard: React.FC<WarehouseWorkingHoursCardProps> = (props) => {
  const { fleetWarehouseDetail } = props;

  const workingHours = fleetWarehouseDetail.workingHours ?? [];
  const hasWorkingHours = workingHours.some((day) => day.isOpen);
  const today = getWarehouseToday();
  const todayHours = workingHours.find((day) => day.day === today);
  const now = getCurrentTime();
  const isOpenNow =
    !!todayHours?.isOpen && !!todayHours.from && !!todayHours.to && todayHours.from <= now && now < todayHours.to;

  return (
    <div className="pt-4 px-4 pb-4">
      {!hasWorkingHours ? (
        <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm text-md text-slate-400">
          Radno vrijeme nije upisano
        </div>
      ) : (
        <>
          <div className="flex items-center justify-between mb-3">
            <Badge
              text={isOpenNow ? "Sada otvoreno" : "Sada zatvoreno"}
              variant={isOpenNow ? "success" : "secondary"}
              height="small"
              showDot
            />
            {isOpenNow && todayHours?.to && (
              <span className="text-sm text-slate-500">Radi do {todayHours.to === "24:00" ? "ponoći" : todayHours.to}</span>
            )}
          </div>

          <div className="border border-slate-200 rounded-sm overflow-hidden">
            {WAREHOUSE_WEEK_DAYS.map(({ day, label }) => {
              const workingDay = workingHours.find((workingDay) => workingDay.day === day);
              const isToday = day === today;

              return (
                <div
                  key={day}
                  className={classNames(
                    "flex items-center justify-between px-3 py-3.5 text-sm border-b border-slate-200 last:border-b-0",
                    isToday ? "bg-blue-50" : "bg-white"
                  )}
                >
                  <span className={classNames(isToday ? "font-semibold text-slate-900" : "text-slate-600")}>
                    {label}
                    {isToday && <span className="ml-2 text-xs font-medium text-blue-600">danas</span>}
                  </span>
                  <span className={classNames(workingDay?.isOpen ? "font-medium text-slate-800" : "text-slate-400")}>
                    {workingDay?.isOpen ? formatWarehouseHours(workingDay.from, workingDay.to) : "Zatvoreno"}
                  </span>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default memo(WarehouseWorkingHoursCard);
